<template>
    <div>
        <!--breadcrumbs area start-->
        <div class="breadcrumbs_area">
            <div class="container">   
                <div class="row">
                    <div class="col-12">
                        <div class="breadcrumb_content">
                            <ul>
                                <li><a href="index.html">home</a></li>
                                <li>My account</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>         
        </div>
        <!--breadcrumbs area end-->
        
        
        <!-- customer login start -->
        <div class="customer_login">
            <div class="container">
                <div class="row">
                <!--login area start-->
                    <div class="col-lg-6 col-md-6">
                        <div class="account_form">
                            <h2>Đăng nhập</h2>
                            <div class="form_group">
                                <p>   
                                    <label>Tài khoản<span>*</span></label>
                                    <input type="text" v-model="model.phone">
                                </p>
                                <p>   
                                    <label>Mật khẩu <span>*</span></label>
                                    <input type="password" v-model="model.password">
                                </p>   
                                <div class="login_submit">
                                    <button v-on:click="login">Đăng nhập</button>
                                </div>
                            </div>
                        </div>    
                    </div>
                    <!--login area start-->
                </div>
            </div>    
        </div>
        <!-- customer login end -->
    </div>
</template>

<script>
import { mapState } from "vuex";
import { sendErrorNotice } from '@/commons/utils'
export default {
    computed: {
        ...mapState({
            token: state => state.authentication.token,
            resData: state => state.authentication.resData,
        }),
    },
    data: () => ({
        loading: false,
        model: {
            phone: '',
            password: ''
        },
        snackbar: false,
        message: '',
        error_message: "Tài khoản hoặc mật khẩu không đúng.",
        null_message: "Tài khoản và mật khẩu không được để trống.",
        wrong_user_pass: false,
        null_user_pass: false,
    }),
    watch: {
        resData() {
            if (this.resData && this.resData.status_code == 400) {
                this.wrong_user_pass = true;
                sendErrorNotice('Tài khoản hoặc mật khẩu không đúng.');
            } 
            // else if (this.token && this.token !== '') {
            //     this.$root.$emit("APP_LOGIN_SUCCESS");
            // }
            this.loading = false;
        }
    },
    methods: {
        login() {
            this.loading = true;
            this.wrong_user_pass = false;
            this.null_user_pass = this.model.phone === '' || this.model.password === '';
            if (!this.null_user_pass) {
                this.$store.dispatch('authentication/login', this.model);
            }
        }
    }

};
</script>